(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["faq-page"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('faq-page-content')) {
    customElements.define('faq-page-content', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.enhance(), { once: true });
        } else this.enhance();
      }
      enhance() {
        if (this.dataset.enhanced) return;
        const source = this.querySelector('.rte');
        if (!source) return;
        const questions = [...source.querySelectorAll('h2,h3,strong,b')].filter(node => {
          if (node.closest('details')) return false;
          if (node.matches('h2,h3')) return node.textContent.trim().length > 0;
          if (node.parentElement.closest('h2,h3,strong,b')) return false;
          if (!/\?["'”’]?\s*$/.test(node.textContent)) return false;
          let previous = node.previousSibling;
          while (previous && previous.nodeType === Node.TEXT_NODE && !previous.textContent.trim()) previous = previous.previousSibling;
          return !previous || previous.nodeName === 'BR';
        });
        if (!questions.length) return;
        const output = document.createDocumentFragment();
        const before = document.createRange();
        before.selectNodeContents(source);
        before.setEndBefore(questions[0]);
        const intro = document.createElement('div');
        intro.className = 'rte';
        intro.append(before.cloneContents());
        output.append(intro);
        questions.forEach((question, index) => {
          const range = document.createRange();
          range.selectNodeContents(source);
          range.setStartAfter(question);
          if (questions[index + 1]) range.setEndBefore(questions[index + 1]);
          const details = document.createElement('details');
          details.className = 'faq-page__item';
          const summary = document.createElement('summary');
          const title = document.createElement('span');
          title.innerHTML = question.innerHTML;
          const icon = document.createElement('span');
          icon.className = 'faq-page__icon';
          icon.setAttribute('aria-hidden', 'true');
          icon.textContent = '+';
          summary.append(title, icon);
          const answer = document.createElement('div');
          answer.className = 'faq-page__answer rte';
          answer.append(range.cloneContents());
          details.append(summary, answer);
          output.append(details);
        });
        this.replaceChildren(output);
        this.dataset.enhanced = 'true';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!window.megakronQuickAdd) {
    window.megakronQuickAdd = true;
    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-quick-add-form]');
      if (!form || !window.megakronCart) return;
      event.preventDefault();
      window.megakronCart.add(form, event.submitter);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
